import WithBaseModels from './withBaseModels'

export default WithBaseModels
